import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var ShareSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M18 14c-1.2 0-2.266.541-3 1.381l-5.092-2.545a3.894 3.894 0 000-1.673L15 8.618c.734.84 1.8 1.382 3 1.382 2.205 0 4-1.795 4-4 0-2.206-1.795-4-4-4s-4 1.794-4 4c0 .287.033.566.092.836L9 9.381A3.978 3.978 0 006 8c-2.205 0-4 1.794-4 4 0 2.205 1.795 4 4 4 1.2 0 2.266-.543 3-1.383l5.092 2.546c-.059.271-.092.55-.092.837 0 2.205 1.795 4 4 4s4-1.795 4-4-1.795-4-4-4z", fill: "currentColor" })] })));
};

export { ShareSolidIcon };
//# sourceMappingURL=ShareSolidIcon.js.map
